import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import TableModuleManagement from 'modules/pages/dacum/moduleManagement/TableModuleManagement';
import React from 'react';

const ModuleManagementPage = () => {
  return (
    <Container fluid>
      <Stack>
        <PageTitle
          title='Competency Module Management'
          description='Manage competency modules for your organization'
        />
        <TableModuleManagement />
      </Stack>
    </Container>
  );
};

export default ModuleManagementPage;
